// AWS Amplify Configuration for DocuMind Authentication
export const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID || '',
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || '',
      region: process.env.REACT_APP_AWS_REGION || 'ap-southeast-2',
      signUpVerificationMethod: 'code',
      loginWith: {
        email: true,
        oauth: {
          domain: process.env.REACT_APP_USER_POOL_DOMAIN || '',
          scopes: ['email', 'openid', 'profile'],
          redirectSignIn: [process.env.REACT_APP_OAUTH_REDIRECT_SIGN_IN || 'http://localhost:3000/auth/callback'],
          redirectSignOut: [process.env.REACT_APP_OAUTH_REDIRECT_SIGN_OUT || 'http://localhost:3000/'],
          responseType: 'code'
        }
      },
    },
  },
};

// Check if auth is enabled
export const isAuthEnabled = process.env.REACT_APP_AUTH_ENABLED === 'true';

// Validate configuration
export const validateAuthConfig = () => {
  if (!isAuthEnabled) {
    console.log('🔓 Authentication disabled in development mode');
    return false;
  }

  const { userPoolId, userPoolClientId, region } = amplifyConfig.Auth.Cognito;
  
  if (!userPoolId || !userPoolClientId) {
    console.error('❌ Missing Cognito configuration. Run configure-auth.sh');
    return false;
  }

  console.log('✅ Cognito configuration loaded:', {
    userPoolId,
    userPoolClientId,
    region
  });
  
  return true;
};
